import { render, staticRenderFns } from "./meal.vue?vue&type=template&id=768315c9&scoped=true&"
import script from "./meal.vue?vue&type=script&lang=js&"
export * from "./meal.vue?vue&type=script&lang=js&"
import style0 from "./meal.vue?vue&type=style&index=0&id=768315c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768315c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('768315c9')) {
      api.createRecord('768315c9', component.options)
    } else {
      api.reload('768315c9', component.options)
    }
    module.hot.accept("./meal.vue?vue&type=template&id=768315c9&scoped=true&", function () {
      api.rerender('768315c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/child/meal.vue"
export default component.exports